export default ["baths", "beds", "foundation", "sqft", "year_built", "parking"];
